// password-utils.js
export function checkPassword(pass, opts = {}) {
    const { minLength = 8, allowedSpecials = '#?!@$%^&*._-' } = opts;
  
    const hasUpper = /[A-Z]/.test(pass);
    const hasLower = /[a-z]/.test(pass);
    const hasDigit = /[0-9]/.test(pass);
  
    // Construye regex de especiales de forma segura
    const escapeClass = (s) => s.replace(/[-\\^]/g, '\\$&');
    const specialRe = new RegExp('[' + escapeClass(allowedSpecials) + ']');
    const hasSpecial = specialRe.test(pass);
  
    const noSpaces = !/\s/.test(pass);
    const lenOK = pass.length >= minLength;
  
    return {
      uppercase: hasUpper,
      lowercase: hasLower,
      digits: hasDigit,
      specialChar: hasSpecial,
      minLength: lenOK,
      noSpaces,
      isValid: hasUpper && hasLower && hasDigit && hasSpecial && lenOK && noSpaces,
    };
  }
  


// WEBPACK FOOTER //
// ./src/helpers/passwordUtils.js